// Brands/models offered when a customer confirms their vehicle.
export const INDIAN_CARS = {
  "Maruti Suzuki": ["Alto K10", "Swift", "Baleno", "Dzire", "Brezza", "Ertiga", "Fronx", "Grand Vitara", "Wagon R", "Celerio"],
  Hyundai: ["i10 Nios", "i20", "Venue", "Creta", "Verna", "Exter", "Alcazar", "Tucson"],
  Tata: ["Tiago", "Tigor", "Altroz", "Punch", "Nexon", "Harrier", "Safari", "Curvv"],
  Mahindra: ["Bolero", "Scorpio", "Scorpio-N", "Thar", "XUV 3XO", "XUV700", "Marazzo"],
  Toyota: ["Glanza", "Urban Cruiser Hyryder", "Innova Crysta", "Innova Hycross", "Fortuner", "Camry"],
  Kia: ["Sonet", "Seltos", "Carens", "Carnival"],
  Honda: ["Amaze", "City", "Elevate", "WR-V"],
  Renault: ["Kwid", "Triber", "Kiger", "Duster"],
  Volkswagen: ["Polo", "Virtus", "Taigun", "Tiguan"],
  Skoda: ["Slavia", "Kushaq", "Kodiaq", "Superb"],
  MG: ["Comet EV", "Astor", "Hector", "ZS EV", "Gloster"],
  Nissan: ["Magnite", "Kicks"],
  "BYD": ["Atto 3", "e6", "Seal"],
  Other: ["Other / Custom model"]
};

export const PPF_OPTIONS = [
  { value: "yes", label: "Yes - already covered with PPF coating" },
  { value: "no", label: "No - not covered with PPF" },
];
export const ppfToBool = (v) => (v === "yes" ? true : v === "no" ? false : null);
export const boolToPpf = (b) => (b === true ? "yes" : b === false ? "no" : "");
/** A vehicle still needs the customer's confirmation when brand, model or the PPF answer is missing. */
export const vehicleNeedsDetails = (v) => !String(v?.make || "").trim() || !String(v?.model || "").trim() || !String(v?.parking_floor || "").trim() || !String(v?.bay || "").trim() || !String(v?.parking_slot_number || "").trim() || typeof v?.ppf_coated !== "boolean";
